import React, { useEffect, useState } from 'react';
import './NumberInput.scss';
import { DebounceInput } from 'react-debounce-input';
import { checkCharacterNumber } from '../../../../services/util';
import { allowedCharacterCode } from '../../../../services/booleanUtil';

interface IProps extends React.HTMLProps<JSX.Element> {
  placeholderText: string;
  inputWidth?: object;
  value: any;
  minParam: boolean;
  defaultValue: number;
  min?: string;
  showSeparators?: boolean;
}
type Props = IProps;

export const NumberInput = ({ placeholderText, inputWidth, value, minParam, defaultValue, min, showSeparators = false }: Props) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (!defaultValue) {
      setDisplayValue('');
      return;
    }

    const parsedNumber = Number(defaultValue);
    if (isNaN(parsedNumber)) {
      setDisplayValue('');
      return;
    }

    const formattedNumber = showSeparators ? parsedNumber.toLocaleString() : parsedNumber.toString();
    setDisplayValue(formattedNumber);
  }, [defaultValue, showSeparators]);

  const handleChange = event => {
    const rawValue = event.target.value.replace(/,/g, '');
    value(minParam, rawValue);
  };

  const handleKeypress = e => {
    const characterCode = e.key;
    if (allowedCharacterCode(characterCode)) {
      const characterNumber = Number(characterCode);
      checkCharacterNumber(characterNumber, e);
    } else {
      return;
    }
  };

  return (
    <div className="number-input-container">
      <DebounceInput
        style={inputWidth || {}}
        placeholder={placeholderText}
        className="input"
        type="text"
        min={min ? min : '0'}
        value={displayValue}
        debounceTimeout={300}
        onKeyDown={event => handleKeypress(event)}
        onChange={event => handleChange(event)}
        inputMode="numeric"
        pattern="[0-9,]*"
      />
    </div>
  );
};

export default NumberInput;
